import { EmployerStatusItem, TemplatesFiltersItem } from "../types";

export const adminEmployersList = 'adminEmployerList';
export const adminTemplatesList = 'adminTemplatesList';
export const spamAccountList = 'spamAccountList';
export const blockAccountList = 'blockAccountList';
export const adminEnterprisesList = 'adminEnterprisesList';
export const adminsList = 'adminsList';
export const adminApplicantsList = 'adminApplicantsList';
export const wotcUsersLIst = 'wotcUsersLIst';
export const adminPostionsList = 'adminPostionsList';
export const adminIndustriesList = 'adminIndustriesList';
export const assignedApplicant = 'assignedApplicant';
export const assignedEmployer = 'assignedEmployer';
export const adminMatrices = 'adminMatrices';
export const templateMatrices = 'templateMatrices';
export const employerTrialCount = 'employerTrialCount';
export const employerSubscriptionDetail = 'employerSubscriptionDetail';
export const employerPaidCount = 'employerPaidCount';
export const errorMessage = 'Sorry, something went wrong';

export const employerStatus: EmployerStatusItem[] = [
    { status: 'unpaid', value: 999, type: "plan" },
    { status: 'past due', value: 1, type: "past_due" },
    { status: 'expired', value: 0, type: "plan" },
];

export const templatesFilters: TemplatesFiltersItem[] = [
    { status: 'Active', value: 2, type: "status" },
    { status: 'Assigned to Companies', value: 0, type: "status" },
    { status: 'Assigned to Enterprise', value: 1, type: "status" },
    { status: 'Inactive', value: 3, type: "status" },
];

export const getFilterStatusButtonColor = (employerStatus: any) => {
    switch (employerStatus) {
        case 'trial':
            return 'yellow';
        case 'past due':
            return 'error';
        case 'paid':
            return 'green';
        case 'enterprise':
            return 'purple';
        case 'expired':
            return 'error';
        default:
            return 'yellow';
    }
};
export const templatesFiltersButtonColor = (employerStatus: any) => {
    switch (employerStatus) {
        case 'Assigned to Companies':
            return 'yellow';
        case 'Inactive':
            return 'error';
        case 'Active':
            return 'green';
        case 'Assigned to Enterprise':
            return 'purple';
        default:
            return 'yellow';
    }
};
